import { Link, Outlet, useLocation, useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Tooltip } from '@packages/ui';
import './layout.css';
import { useEffect } from 'react';

const removeBeginningSlash = (path: string) => {
  return path.startsWith('/') ? path.slice(1) : path;
};

export const Layout = () => {
  const { lang } = useParams<{ lang: string }>();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { t, i18n } = useTranslation();

  const toggleLanguage = () => {
    if (i18n.language === 'en') {
      navigate('/de/' + removeBeginningSlash(pathname.split('en/').pop() ?? ''));
    } else {
      navigate('/en/' + removeBeginningSlash(pathname.split('de/').pop() ?? ''));
    }
  };

  useEffect(() => {
    if (['de', 'en'].includes(lang ?? '') && lang !== i18n.language) {
      setTimeout(() => {
        i18n.changeLanguage(lang);
      }, 0);
    }
  }, [lang, i18n]);

  const languageEmoji = i18n.language === 'en' ? '🇩🇪' : '🇬🇧';

  return (
    <div className="min-h-screen bg-[#e4e7deff] relative">
      <div className="min-h-screen h-full flex flex-col">
        <main className="p-4 h-full grow">
          <Outlet />
        </main>
        <footer className="border-t py-2 font-bold backdrop-blur-lg">
          <div className="container space-x-8 text-center flex justify-center items-center text-xs">
            <a href="https://magic-speech.com">Magic Speech</a>
            <Link to={`/${i18n.language}/imprint`}>{t('imprint')}</Link>
            <Link to={`/${i18n.language}/privacy`}>{t('privacy')}</Link>
            <Tooltip content={t('changeLanguage')} delayDuration={0}>
              <button onClick={toggleLanguage} className="text-lg leading-[12px]">
                {languageEmoji}
              </button>
            </Tooltip>
          </div>
        </footer>
      </div>
    </div>
  );
};
